import React, { useState } from 'react';
import _ from 'lodash';
import { Dropdown, DropdownTypes } from './Dropdown';
import { BaseInputProps, Option } from './index';
import useDataLoader from 'data-loader';
import { LoadingAnimation } from '../../Common';

interface Props<Type extends DropdownTypes = number> extends BaseInputProps<Type> {
  getDataFunc: () => Promise<{ [key: string]: any }[]>;
  onOptionChanged?: (option: Option | null) => void,
  idField?: string;
  labelField?: string;
  source: string
  hideWhenNoOptions?: boolean
}

export function AsyncDropdown<Type extends DropdownTypes = number>(props: Props<Type>) {
  const idField = props.idField || 'id';
  const labelField = props.labelField || 'name';

  const [data, setData] = useState<{ [key: string]: any }[]>();

  useDataLoader(
    props.getDataFunc,
    setData
  );

  if (data) {
    const options = data.map((v) => ({
      value: v[idField] as Type,
      label: v[labelField] as string,
      _data: v
    }));

    const show = !props.hideWhenNoOptions || options.length > 0;

    if (show) {
      return (
        <Dropdown<Type>
          options={options}
          {..._.omit(props, 'idField', 'labelField')}
          source={props.source}
          placeholder={options.length ? props.placeholder : 'Loading...'}
        />
      );
    } else {
      return null;
    }
  } else {
    return (<LoadingAnimation />);
  }
}
